import type { CreateRecordingRequestBody } from "@/common/types/visits";
import { createRecording } from "@/services/visits";
import { usePostOnboardingStore } from "@/store/postOnboarding.store";
import { useState } from "react";

export const useRecordingSubmit = (): {
  submitRecording: (body: CreateRecordingRequestBody) => Promise<void>;
  result: boolean;
  loading: boolean;
  error: string | null;
} => {
  const [result, setResult] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const submitRecording = async (
    body: CreateRecordingRequestBody
  ): Promise<void> => {
    setLoading(true);
    setError(null);
    try {
      await createRecording(body);
      setResult(true);
      usePostOnboardingStore.getState().markDone();
    } catch (error) {
      setError(error as string);
    } finally {
      setLoading(false);
    }
  };

  return {
    submitRecording,
    result,
    loading,
    error,
  };
};
